/**
 * Decide whether the current property should be (re)bound to the ref_ta token.
 *
 * One ref_ta token maps to exactly one property, so:
 * - a token that differs from the stored one is a genuinely new referral → bind
 * - no property bound yet (fresh session or legacy cookie) → bind
 * - the same token arriving on a different property is the auto-append leak
 *   (buildDetailPageUrl re-appends ref_ta to every internal link) → do NOT bind
 *
 * @param urlToken     ref_ta value currently in the URL (non-empty)
 * @param storedToken  ref_ta value previously persisted, if any
 * @param storedPropId property id previously bound to the stored token, if any
 */
export const shouldBindRefTaProperty = (
  urlToken: string,
  storedToken: string | undefined,
  storedPropId: string | undefined,
): boolean => urlToken !== storedToken || !storedPropId
